import { animated, useSpring } from '@react-spring/web';
import { useGesture } from '@use-gesture/react';
import { FC, ReactNode, useRef } from 'react';
import './style.less';

export type ZoomProps = {
  maxZoom?: number;
  onTap?: () => void;
  onZoomChange?: (zoom: number) => void;
  children?: ReactNode;
};

export const Zoom: FC<ZoomProps> = (props) => {
  const classPrefix = `v-zoom`;
  const controlRef = useRef<HTMLDivElement>(null);
  const [{ zoom, x, y }, api] = useSpring(() => ({
    zoom: 1,
    x: 0,
    y: 0,
    config: { tension: 300 },
  }));

  const pinchLockRef = useRef(false);

  useGesture(
    {
      onDrag: (state) => {
        if (state.tap && state.elapsedTime > 0) {
          // 判断点击时间>0是为了过滤掉非正常操作，例如用户长按选择图片之后的取消操作（也是一次点击）
          props.onTap?.();
          return;
        }
        if (pinchLockRef.current) return;
        const currentZoom = zoom.get();
        if (currentZoom <= 1) {
          api.start({
            x: 0,
            y: 0,
          });
        } else {
          const [x, y] = state.offset;
          api.start({
            x,
            y,
            immediate: true,
          });
        }
      },
      onPinch: (state) => {
        pinchLockRef.current = !state.last;
        const [d] = state.offset;
        if (d < 0) return;
        // pinch的rubberband不会自动弹回bound，这里手动实现了
        const zoom = state.last ? Math.max(Math.min(d, props.maxZoom as number), 1) : d;
        api.start({
          zoom,
          immediate: !state.last,
        });
        props.onZoomChange?.(zoom);
        if (state.last && zoom <= 1) {
          api.start({
            x: 0,
            y: 0,
          });
        }
      },
    },
    {
      target: controlRef,
      drag: {
        // filterTaps: true,
        from: () => [x.get(), y.get()],
      },
      pinch: {
        from: () => [zoom.get(), 0],
      },
      pointer: { touch: true },
    },
  );

  return (
    <div className={`${classPrefix}`}>
      <div className={`${classPrefix}-control`} ref={controlRef}>
        <animated.div className={`${classPrefix}-zoom`} style={{ scale: zoom, x, y }}>
          {props.children}
        </animated.div>
      </div>
    </div>
  );
};

Zoom.defaultProps = {
  maxZoom: 2,
};
